import { fmtDate } from "../Utils/excelExport";

const MilkEntryTable = ({ records }) => {
  if (!records.length) {
    return <div className="no-data"><p>या कालावधीसाठी नोंदी उपलब्ध नाहीत.</p></div>;
  }

  return (
    <div className="table-wrapper">
      <table className="emc-table">
        <thead>
          <tr>
            <th>दिनांक</th>
            <th>वेळ</th>
            <th>लि.</th>
            <th>फॅट</th>
            <th>SNF</th>
            <th>दर</th>
            <th>रक्कम</th>
          </tr>
        </thead>
        <tbody>
          {records.map((r, i) => (
            <tr key={i}>
              <td>{fmtDate(r.date)}</td>
              <td>{r.mr_milking_shift}</td>
              <td>{r.qty}</td>
              <td>{r.fat}</td>
              <td>{r.snf}</td>
              <td>₹{r.rate}</td>
              <td>₹{r.total_rate}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MilkEntryTable;
